
import CommonAcf from '~/components/common/CommonAcf.vue'
import { createPopup } from '@typeform/embed'

export default CommonAcf.extend({
  name: 'AcademiaComponent',
  props: ['block'],
  data() {
    return {
      toggleAcademiaForm: () => {},
      btnMinHeight: 56,
    }
  },
  mounted() {
    if (this?.block?.typeformId) {
      const { toggle } = createPopup(this.block.typeformId)
      // @ts-ignore
      this.toggleAcademiaForm = toggle
    }
  },
  methods: {
    buttonClick() {
      if (this?.block?.typeformId) {
        this.toggleAcademiaForm()
      }
      else if(this?.block?.button?.link.length > 0) {
        window.open(this.block.button.link, '_blank')
      }
    }
  }
})
